<script setup lang="ts">
import { useAppIndexStore } from '@base/stores/indexStore'
import { type IPdfCustomData, PARAM } from '@amirada/lib-wilo-shared'

const indexStore = useAppIndexStore()

const extData = computed((): IPdfCustomData | undefined => {
  return indexStore.state.paramData[PARAM.externalData]
})
</script>

<template>
  <template v-if="extData">
    <div v-for="(section, sIndex) in extData.sections" :key="sIndex">
      <h1 v-html="section.title" />
      <template v-if="section.lists">
        <div v-for="list of section.lists" :key="list.title" class="mb-4">
          <table class="w-full">
            <thead v-if="list.title">
              <tr>
                <th colspan="2" class="text-left p-2" v-html="list.title" />
              </tr>
            </thead>
            <tbody>
              <template v-for="item in list.items" :key="item.label">
                <tr class="odd:bg-gunmetal-5 even:bg-gunmetal-4">
                  <td class="text-left hyphens-auto p-2" v-html="item.label" />
                  <td class="text-left hyphens-auto p-2" v-html="item.value" />
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </template>
      <template v-if="section.images">
        <div v-for="image of section.images" :key="image.src">
          <h3 v-if="image.title" class="mb-4" v-html="image.title" />
          <div v-if="image.subtitle" class="mb-4" v-html="image.subtitle" />
          <Image :src="image.src" :alt="image.title" class="mb-4" />
          <div v-if="image.footer" v-html="image.footer" />
        </div>
      </template>
    </div>
  </template>
</template>
